import { useMemo } from "react";
import { useAddCaseFormContext } from "../contexts/AddCaseFormContext";

const getHasUserUploadedAnyMedicalRecords = (clientMedicalFiles) => {
    return clientMedicalFiles && (clientMedicalFiles.postAccident?.medicalRecords?.length || clientMedicalFiles.preAccident?.medicalRecords?.length);
}

const usePlaintiffs = () => {
    const { formik, selectedTiffIndex } = useAddCaseFormContext();
    const plaintiffs = useMemo(() =>
        formik.values.clients || [],
        [formik.values.clients]
    );
    const currentClient = useMemo(()=>
        plaintiffs[selectedTiffIndex],
        [plaintiffs, selectedTiffIndex]
    );

    const isCurrentClientHasAnyMedicalRecords = useMemo(()=>{
        return getHasUserUploadedAnyMedicalRecords(currentClient?.medicalProviders)
    }, [currentClient]);

    const hasAnyPlaintiffMedicalRecords = useMemo(()=>{
        return plaintiffs.some(client => getHasUserUploadedAnyMedicalRecords(client?.medicalProviders));
    }, [plaintiffs]);

    return {
        plaintiffs,
        currentClient,
        isCurrentClientHasAnyMedicalRecords,
        hasAnyPlaintiffMedicalRecords
    }
}

export default usePlaintiffs;